import { postApi } from "../../config/api";
import { errorNotification } from "../../Generic/Notifications";

const ControlService = {

    "Move Pusher Forward": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=di_move_pusher_forward",payload,kitchenId);
    },

    "Move Pusher Backward": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=di_move_pusher_backward",payload,kitchenId);
    },

    "Move Shutter Upwards": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=di_move_shutter_upwards",payload,kitchenId);
    },

    "Move Shutter Downwards": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=di_move_shutter_downwards",payload,kitchenId);
    },

    "Move Cleaning Unit Up":async function (payload,kitchenId){
        return await postApi("/performTask?taskName=move_cleanig_unit_up",payload,kitchenId);
    },

    "Move Cleaning Unit Down":async function (payload,kitchenId){
        return await postApi("/performTask?taskName=move_cleanig_unit_down",payload,kitchenId);
    },

    "Rotate Mixer":async function (payload,kitchenId){
        return await postApi("/performTask?taskName=start_mixer_rotation",payload,kitchenId);
    },

    "Stop Mixer Rotation":async function (payload,kitchenId){
        return await postApi("/performTask?taskName=stop_mixer_rotation",payload,kitchenId);
    },
};

export default ControlService;